import React from 'react';
import { Routes, Route, } from 'react-router-dom';
import SearchProducts from '../screens/SearchProducts';

const Router = () => {
  return (
    <Routes>
      <Route path="/:url" element={<SearchProducts />} />
    </Routes>
  )
}

export default Router;